import React from 'react';
import { Tooltip } from '../Tooltip';
import { SectionIntro } from '../SectionIntro';
export const ProductChannelFit = ({
  primaryChannel,
  updateSimulation
}) => {
  const channels = ['Outbound Sales (CAC: $5,000)', 'Inbound Marketing (CAC: $2,500)', 'Self-Service (CAC: $500)', 'Viral/Network (CAC: $100)'];
  const getChannelInsight = (channel: string) => {
    if (channel.includes('Outbound')) {
      return 'High-touch sales works for complex, high-value products. Requires strong sales team and longer sales cycles.';
    }
    if (channel.includes('Inbound')) {
      return 'Content and SEO-driven growth. Great for products with clear search intent and educational needs.';
    }
    if (channel.includes('Self-Service')) {
      return 'Users can sign up and get value independently. Requires intuitive UX and fast Time To Value.';
    }
    return 'Users bring other users. The holy grail of growth, but requires strong network effects built into the product.';
  };
  return <div className="space-y-4" data-id="element-180">
      <SectionIntro title="Product ↔ Channel Fit" description="Not all products can grow through all channels. Your product's complexity, pricing, and value delivery determine which acquisition channels will work efficiently." whyItMatters="Choosing the wrong channel wastes money and time. A $50/month product can't support a $5,000 CAC sales team. A complex enterprise product won't work with viral growth. Match your product to the right channel." data-id="element-181" />
      <div className="space-y-2" data-id="element-182">
        <label className="flex items-center text-sm text-gray-300" data-id="element-183">
          Primary Acquisition Channel
          <Tooltip title="Acquisition Channel Strategy" description="Different channels have different Customer Acquisition Costs (CAC) and work for different product types. Outbound sales ($5k+ CAC) works for enterprise. Viral growth ($100 CAC) requires built-in sharing. Choose the channel that matches your product's natural motion." learnMoreUrl="https://www.reforge.com/blog/how-to-build-a-growth-model" data-id="element-184" />
        </label>
        <select value={primaryChannel} onChange={e => updateSimulation({
        primaryChannel: e.target.value,
        cac: parseInt(e.target.value.match(/\$(\d+)/)[1])
      })} className="w-full bg-[#0F172A] border border-[#334155] text-white py-2 px-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500" data-id="element-185">
          {channels.map(channel => <option key={channel} value={channel} data-id="element-186">
              {channel}
            </option>)}
        </select>
        <div className="mt-2 p-3 bg-blue-500 bg-opacity-10 border border-blue-500 border-opacity-30 rounded-lg" data-id="element-187">
          <div className="text-xs text-gray-300 leading-relaxed" data-id="element-188">
            💡 <strong data-id="element-189">Channel Insight:</strong>{' '}
            {getChannelInsight(primaryChannel)}
          </div>
        </div>
      </div>
      <div className="mt-6" data-id="element-190">
        <div className="flex justify-between items-center mb-2" data-id="element-191">
          <span className="text-sm text-gray-300" data-id="element-192">
            Product-Channel Alignment
          </span>
        </div>
        <div className="w-full bg-gray-700 rounded-full h-2.5" data-id="element-193">
          <div className="bg-green-500 h-2.5 rounded-full" style={{
          width: '85%'
        }} data-id="element-194"></div>
        </div>
        <div className="flex justify-end mt-1" data-id="element-195">
          <div className="text-green-500 flex items-center text-sm" data-id="element-196">
            <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" className="mr-1" data-id="element-197">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" data-id="element-198"></path>
              <polyline points="22 4 12 14.01 9 11.01" data-id="element-199"></polyline>
            </svg>
            Good alignment
          </div>
        </div>
      </div>
    </div>;
};